// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__Cks0B","notes":"Notes_notes___4FJC"};